<template>
<div class="fill-canvas" v-if="visible">
  <v-container fluid fill-height>
    <v-row
      class="fill-height"
      align-content="center"
      justify="center">
      <v-col cols="4">
        <div class="text-center mb-3">
          NOW LOADING...
        </div>
        <v-progress-linear
          color="light-blue"
          indeterminate
          rounded
          striped
          height="4"></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    
  },
  methods: {
    
  },
}
</script>

<style lang='scss' scoped>
.fill-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
